import { Action, ApiState } from '../../../types';
import { GeneralSetting } from '../../../services/types/Admin';
import { serviceReducer } from '../../../shared/hooks/serviceReducer';

export type GeneralSettingAction =
  | Action<GeneralSetting[], void>
  | { type: 'ORDER'; data: GeneralSetting[] };

const reducer = (
  state: ApiState<GeneralSetting[], void>,
  action: GeneralSettingAction
): ApiState<GeneralSetting[], void> => {
  switch (action.type) {
    case 'ORDER': {
      return { ...state, data: action.data };
    }
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
